import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: zeplinColor.Neutral11,
    padding: '12px 20px',
    flex: 1,
    borderRadius: '14px',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px',
  },

  divider: {
    borderWidth: '1px',
    borderColor: zeplinColor.Neutral9,
    height: '32px',
    alignSelf: 'center',
    ':last-child': {
      display: 'none',
    },
  },
};
